var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero',{attrs:{"titleStrong":"Cutting edge research","title":"to create new medicines","imageUrl":_vm.Image}}),_c('Main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }